import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Container from '@mui/material/Container'
import { createContext } from 'react'
import { NavLink } from 'components/nav-link'
import {
  Backdrop,
  Box,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { NavbarList } from 'components/nav-bar'
import { CartHeaderButton } from 'components/cart'
import { ErrorBoundary } from 'react-error-boundary'
import { RuntimeErrorDialog } from 'lib/runtime-error-dialog'
import { SearchAutocomplete } from 'components/search-autocomplete'
import { LanguageSelector } from 'components/language-selector'
import { ProfileMenu } from 'components/profile-menu'
import { useTranslation } from 'react-i18next'
import { useUser } from 'api/hooks/use-user'
import { Contacts } from 'components/contacts'
import { layoutService } from 'services'
import logo from 'assets/icons/logo.png'
import { useEducationMode } from 'api/hooks/use-education-mode'
import { pageConfig } from 'app/page-config'
import { ProgressBar } from 'components/progress-bar'

export const AppContext = createContext({ globalSearch: '' })

export const AppLayout = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const mdUpMatch = useMediaQuery(theme.breakpoints.up('md'))
  const navigate = useNavigate()
  const { user } = useUser()
  const location = useLocation()
  const { subCategory } = useParams()
  const { educationMode, disableEducationMode } = useEducationMode()

  return (
    <>
      <Backdrop
        open={educationMode && !!subCategory}
        onClick={disableEducationMode}
        sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1 })}
      />
      {/* Header -------------------------------------------- */}
      <AppBar
        position="relative"
        sx={{ backgroundColor: theme.palette.common.white, zIndex: 2 }}
      >
        <Container maxWidth="xl" sx={{ pt: 1, pb: 0.25 }}>
          {/* Mobile variant -------------------------------------------- */}
          {/* <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavigation}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorNavigation}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorNavigation)}
                onClose={handleCloseNavigation}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavigation}>
                    <Typography textAlign="center">{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box> */}
          {/* <CustomLink
              to="/"
              style={{
                display: mdUpMatch ? 'none' : 'flex',
                flexGrow: 1,
                ...logoStyles,
              }}
            >
              AGROSOTA
            </CustomLink> */}

          {/* Desktop variant ------------------------------- */}
          <Stack direction="row" justifyContent="space-between">
            {/* Logo ------------------------------------------ */}
            <Box sx={{ width: '33%' }}>
              <NavLink
                to="/"
                styles={{
                  display: mdUpMatch ? 'inline-flex' : 'none',
                  width: 'auto',
                  maxHeight: '40px',
                  marginTop: '8px',
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  sx={{ maxHeight: '40px' }}
                  alt="Logo"
                />
              </NavLink>
            </Box>

            <Stack spacing={0.5} alignItems="center" sx={{ mx: 1 }}>
              {/* Navigation ------------------------------------------ */}
              <NavbarList />
              {/* Search ------------------------------------------ */}
              <SearchAutocomplete />
            </Stack>

            <Stack sx={{ width: '33%', alignItems: 'end' }}>
              <Stack spacing={0.5} sx={{ alignItems: 'center' }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={0.5}
                  sx={{ pt: '6px' }}
                >
                  <Box>
                    {user ? (
                      <Stack direction="row" spacing={0.5}>
                        {/* Cart --------------------------------------------- */}
                        <CartHeaderButton />

                        {/* Profile menu ------------------------------------ */}
                        <ProfileMenu />
                      </Stack>
                    ) : (
                      <Button
                        onClick={() => {
                          if (location.pathname !== pageConfig.auth) {
                            navigate(pageConfig.auth, {
                              state: { from: location },
                            })
                          }
                        }}
                        color="success"
                        sx={{ height: '33px' }}
                      >
                        {t('sign_up_or_sign_in')}
                      </Button>
                    )}
                  </Box>

                  {/* Language Selector ------------------------------------------ */}
                  <LanguageSelector />
                </Stack>

                {/* Contacts --------------------------------------------- */}
                <Contacts />
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </AppBar>
      <ProgressBar />
      {/* Main -------------------------------------------- */}
      <Container
        component="main"
        disableGutters
        maxWidth="xl"
        sx={{
          display: 'flex',
          height: layoutService.getAppContainerHeight('100vh'),
          background:
            'linear-gradient(90deg, rgba(250,250,250,1) 85%, rgba(255,255,255,1) 100%)',
        }}
      >
        <ErrorBoundary FallbackComponent={RuntimeErrorDialog}>
          <Outlet />
        </ErrorBoundary>
      </Container>

      {/* Footer -------------------------------------------- */}
      {/* <Stack
        component="footer"
        justifyContent="center"
        sx={{
          height: FOOTER_HEIGHT,
          borderTop: `1px solid ${grey[300]}`,
        }}
      >
        <Container maxWidth="xl">&copy; Agrosota 2024</Container>
      </Stack> */}
    </>
  )
}
